import { client as create } from "@educabot/fetcher"

export const client = create(import.meta.env.VITE_BASE_API_URL)
